import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Icons } from '..';
import styles from './warning.module.scss';

const Warning = ({ children, ...props }) => (
  // eslint-disable-next-line react/prop-types
  <div className={cn(styles.warning, props.className)}>
    <p>
      <Icons.Warning className={styles.icon} />
      {children}
    </p>
  </div>
);

Warning.propTypes = {
  /** The message shown in the warning */
  children: PropTypes.any,
};

Warning.defaultProps = {
  children: undefined,
};

export default Warning;
